import { AxiosError } from 'axios';
import { TFormattedErrors } from 'src/types';
import get from 'lodash/get';
import * as yup from 'yup';

export const networkErrorMessage = 'Oh! Something went wrong!';

export const getServerError = (error: unknown) => {
    if (Array.isArray((error as AxiosError<{ message: string[] }>)?.response?.data?.message)) {
        return (error as AxiosError<{ message: string[] }>).response?.data.message[0];
    }

    if (typeof (error as AxiosError<{ message: string }>)?.response?.data?.message === 'string') {
        return (error as AxiosError<{ message: string }>).response?.data.message;
    }

    return (error as Error).message || networkErrorMessage;
};

export const formatError = (error: AxiosError<{ message: string }>): TFormattedErrors => {
    const errors = get(error, 'response.data.message', '');
    return [errors.length ? errors : error.toString()];
};

export const prepareErrorsFromYupValidationError = <T extends Record<string, unknown>>(
    error: yup.ValidationError
): Record<keyof T, string[]> | Partial<Record<keyof T, string[]>> => {
    return error.inner.reduce(
        (acc: Record<keyof T, string[]> | Partial<Record<keyof T, string[]>>, err) => {
            if (!err) {
                return acc;
            }
            return { ...acc, [err.path as keyof T]: err.errors };
        },
        {}
    );
};
